(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /*
    Infinite scroll for collection pages.
    - Fetches the next page with the Section Rendering API and appends only new product cards.
    - After N automatic loads (block setting) it shows a "Load more" button instead.
    - Back from a product page restores the loaded pages and the scroll position.
    - The numbered pagination stays in the HTML for crawlers and comes back if loading fails.
  */
  if (!customElements.get('collection-infinite-scroll')) {
    customElements.define('collection-infinite-scroll', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        const scope = this.closest('[data-scroll-to]') || this.closest('.collection-content') || document;
        this.grid = scope.querySelector('.collection-grid__wrapper .grid--uniform');
        this.pagination = this.querySelector('.pagination');
        this.moreButton = this.querySelector('.collection-infinite-scroll__more');
        this.nextUrl = this.dataset.nextUrl;
        this.autoBatches = Math.max(1, Number(this.dataset.autoBatches || 3));
        this.autoLoaded = 0;
        this.loadedUrls = [];
        this.storageKey = `collection-infinite-scroll:${window.location.pathname}${window.location.search}`;

        if (!this.grid || !this.pagination || !this.nextUrl) return;

        this.classList.add('is-ready');
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage({ auto: true });
        }, { rootMargin: '600px 0px' });

        this.moreButton?.addEventListener('click', () => this.loadNextPage({ auto: false }));

        this.onProductClick = (event) => {
          if (event.target.closest('a[href*="/products/"]')) this.saveState();
        };
        this.grid.addEventListener('click', this.onProductClick);

        this.restoreState().finally(() => {
          if (this.nextUrl && this.isConnected) this.watch();
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.controller) this.controller.abort();
        this.grid?.removeEventListener('click', this.onProductClick);
      }

      watch() {
        const manual = this.autoLoaded >= this.autoBatches;
        this.classList.toggle('is-manual', manual);
        if (this.moreButton) this.moreButton.hidden = !manual || !this.nextUrl;
        if (!manual) this.observer.observe(this);
      }

      saveState() {
        if (!this.loadedUrls.length) return;
        try {
          sessionStorage.setItem(this.storageKey, JSON.stringify({
            urls: this.loadedUrls,
            autoLoaded: this.autoLoaded,
            scrollY: window.scrollY
          }));
        } catch (error) {}
      }

      async restoreState() {
        let state = null;
        try {
          state = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
          sessionStorage.removeItem(this.storageKey);
        } catch (error) {
          state = null;
        }

        const navigation = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        if (!state || !Array.isArray(state.urls) || !navigation || navigation.type !== 'back_forward') return;

        for (const url of state.urls) {
          if (!this.nextUrl || url !== this.nextUrl) break;
          await this.loadNextPage({ auto: false, restoring: true });
        }
        this.autoLoaded = Number(state.autoLoaded) || this.autoLoaded;
        requestAnimationFrame(() => window.scrollTo(0, Number(state.scrollY) || 0));
      }

      async loadNextPage({ auto = true, restoring = false } = {}) {
        if (this.loading || !this.nextUrl) return;

        this.loading = true;
        this.classList.add('is-loading');
        this.observer.unobserve(this);
        if (this.moreButton) this.moreButton.hidden = true;
        this.controller = new AbortController();
        const requestedUrl = this.nextUrl;

        try {
          const url = new URL(requestedUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: this.controller.signal
          });

          if (!response.ok) throw new Error(response.statusText);

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incomingLoader = documentFragment.querySelector('collection-infinite-scroll');
          const incomingGrid = documentFragment.querySelector('.collection-grid__wrapper .grid--uniform');

          if (!incomingGrid) throw new Error('Product grid not found');

          const productIds = new Set(
            Array.from(this.grid.querySelectorAll('[data-product-id]'), (item) => item.dataset.productId)
          );
          const newItems = document.createDocumentFragment();
          const addedItems = [];

          incomingGrid.querySelectorAll('.grid-product[data-product-id]').forEach((item) => {
            if (!productIds.has(item.dataset.productId)) {
              productIds.add(item.dataset.productId);
              addedItems.push(item);
              newItems.appendChild(item);
            }
          });

          this.grid.appendChild(newItems);
          addedItems.forEach((item) => this.initColorSwatches(item));
          this.loadedUrls.push(requestedUrl);
          if (auto && !restoring) this.autoLoaded += 1;
          this.nextUrl = incomingLoader ? incomingLoader.dataset.nextUrl : '';

          if (incomingLoader) {
            const incomingPagination = incomingLoader.querySelector('.pagination');
            if (incomingPagination) this.pagination.innerHTML = incomingPagination.innerHTML;
          }

          if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
            window.theme.reinitProductGridItem(this.grid);
          }

          document.dispatchEvent(new CustomEvent('collection:page-loaded', {
            detail: { url: url.toString(), items: addedItems }
          }));
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.classList.remove('is-ready');
            this.nextUrl = '';
          }
        } finally {
          this.loading = false;
          this.classList.remove('is-loading');
          if (!this.nextUrl) this.classList.remove('is-manual');
          if (this.nextUrl && this.isConnected && !restoring) this.watch();
        }
      }

      initColorSwatches(item) {
        item.querySelectorAll('.color-swatch--with-image').forEach((swatch) => {
          const image = item.querySelector('.grid-product__color-image--' + swatch.dataset.variantId);
          if (!image) return;

          swatch.addEventListener('mouseenter', () => {
            image.style.backgroundImage = 'url(' + swatch.dataset.variantImage + ')';
            image.classList.add('is-active');
          });

          swatch.addEventListener('mouseleave', () => image.classList.remove('is-active'));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peraan-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.prReady) return;
      root.dataset.prReady = 'true';

      const track = root.querySelector('[data-pr-track]');
      const prev = root.querySelector('[data-pr-prev]');
      const next = root.querySelector('[data-pr-next]');
      const lightbox = root.querySelector('[data-pr-lightbox]');
      const lightboxImg = root.querySelector('[data-pr-lightbox-img]');
      if (!track) return;

      const step = () => {
        const card = track.querySelector('.peraan-reviews__card');
        if (!card) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      };

      prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      const close = () => {
        lightbox.hidden = true;
        lightboxImg.src = '';
        document.documentElement.style.overflow = '';
      };

      root.querySelectorAll('[data-pr-image]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          lightboxImg.src = thumb.dataset.prImage;
          lightboxImg.alt = thumb.dataset.prAuthor || '';
          lightbox.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        });
      });

      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox || event.target.closest('[data-pr-close]')) close();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && lightbox && !lightbox.hidden) close();
      });
    };

    const initAll = () => document.querySelectorAll('[data-peraan-reviews]').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ramsha-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Clones added at each end for the infinite loop (enough to fill the side space on desktop)
    const CLONES_PER_SIDE = 3;

    const initialize = (section) => {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const track = section.querySelector('[data-slider-track]');
      const realSlides = [...section.querySelectorAll('[data-slider-slide]')];
      const previous = section.querySelector('[data-slider-previous]');
      const next = section.querySelector('[data-slider-next]');
      const pagination = section.querySelector('[data-slider-pagination]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const count = realSlides.length;
      const loop = count >= 3;
      const cloneCount = loop ? Math.min(CLONES_PER_SIDE, count) : 0;
      let activeIndex = 0; // position in `slides` (clones included)
      let autoplayTimer;

      if (!track || count === 0) return;

      realSlides.forEach((slide, index) => {
        slide.dataset.realIndex = index;
        const dot = document.createElement('span');
        dot.className = `ramsha-featured__dot${index === 0 ? ' is-active' : ''}`;
        pagination?.append(dot);
      });

      const dots = [...(pagination?.children || [])];

      // Clones reuse the same image URLs (browser cache), stay lazy and are hidden from assistive tech
      const makeClone = (slide) => {
        const clone = slide.cloneNode(true);
        clone.classList.remove('is-active');
        clone.dataset.clone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        clone.querySelectorAll('img').forEach((image) => {
          image.setAttribute('loading', 'lazy');
          image.removeAttribute('fetchpriority');
        });
        return clone;
      };

      if (loop) {
        realSlides.slice(-cloneCount).forEach((slide) => track.insertBefore(makeClone(slide), realSlides[0]));
        realSlides.slice(0, cloneCount).forEach((slide) => track.append(makeClone(slide)));
        track.classList.add('is-looping');
      }

      const slides = [...track.querySelectorAll('[data-slider-slide]')];
      const realPosition = (index) => cloneCount + Number(slides[index].dataset.realIndex);

      const setActive = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        const realIndex = Number(slides[activeIndex].dataset.realIndex);
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === activeIndex));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === realIndex));
        if (!loop) {
          if (previous) previous.disabled = activeIndex === 0;
          if (next) next.disabled = activeIndex === slides.length - 1;
        }
      };

      const centerOffset = (index) => {
        const trackBounds = track.getBoundingClientRect();
        const targetBounds = slides[index].getBoundingClientRect();
        const targetLeft = track.scrollLeft + targetBounds.left - trackBounds.left - (track.clientWidth - targetBounds.width) / 2;
        const maximumLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        return Math.max(0, Math.min(targetLeft, maximumLeft));
      };

      const goTo = (index, instant) => {
        const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({
          left: centerOffset(targetIndex),
          behavior: instant || reduceMotion ? 'auto' : 'smooth'
        });
        setActive(targetIndex);
      };

      // Jump without animation (e.g. from a clone to the matching real slide)
      const jumpTo = (index) => {
        track.classList.add('is-jumping');
        goTo(index, true);
        window.requestAnimationFrame(() => window.requestAnimationFrame(() => track.classList.remove('is-jumping')));
      };

      const findCenteredSlide = () => {
        const center = track.getBoundingClientRect().left + track.clientWidth / 2;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;
        slides.forEach((slide, index) => {
          const bounds = slide.getBoundingClientRect();
          const distance = Math.abs(bounds.left + bounds.width / 2 - center);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });
        setActive(nearestIndex);
      };

      // Once scrolling stops on a clone, swap to the real slide (looks identical)
      const settle = () => {
        if (!loop) return;
        findCenteredSlide();
        if (slides[activeIndex].dataset.clone === 'true') jumpTo(realPosition(activeIndex));
      };

      const restartAutoplay = () => {
        window.clearInterval(autoplayTimer);
        if (section.dataset.autoplay !== 'true' || reduceMotion || count < 2) return;
        const speed = Number(section.dataset.autoplaySpeed) || 5000;
        autoplayTimer = window.setInterval(() => {
          if (loop) goTo(activeIndex + 1);
          else goTo(activeIndex >= slides.length - 1 ? 0 : activeIndex + 1);
        }, speed);
      };

      let scrollFrame;
      let settleTimer;
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(findCenteredSlide);
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(settle, 150);
      }, { passive: true });
      track.addEventListener('scrollend', () => {
        window.clearTimeout(settleTimer);
        settle();
      });

      previous?.addEventListener('click', () => {
        goTo(activeIndex - 1);
        restartAutoplay();
      });

      next?.addEventListener('click', () => {
        goTo(activeIndex + 1);
        restartAutoplay();
      });

      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') goTo(activeIndex - 1);
        if (event.key === 'ArrowRight') goTo(activeIndex + 1);
      });

      section.addEventListener('mouseenter', () => window.clearInterval(autoplayTimer));
      section.addEventListener('mouseleave', restartAutoplay);
      section.addEventListener('focusin', () => window.clearInterval(autoplayTimer));
      section.addEventListener('focusout', restartAutoplay);

      // Keep the active slide centred when the viewport width changes
      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => jumpTo(activeIndex), 150);
      }, { passive: true });

      if (loop) jumpTo(cloneCount);
      else setActive(0);
      restartAutoplay();
    };

    document.querySelectorAll('[data-ramsha-featured]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-ramsha-featured]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
